<app-view-item *ngIf="readonly" [text]="selected?.code" [tabindex]="tabindex"></app-view-item>
<div class="term-select-container" *ngIf="!readonly">
  <nz-select #selector nzShowSearch nzServerSearch [nzAllowClear]="true" [nzBackdrop]="addBackdrop" (keydown)="handleKeyDown($event)"
    [nzFilterOption]="nzFilterOption" (nzOnSearch)="search($event, 20)" (nzOpenChange)="onDropdownOpenChange($event)"
    (nzScrollToBottom)="loadMore()" [nzCustomTemplate]="displayTpl" (click)="handleClick($event)" [(ngModel)]="value"
    (ngModelChange)="valueChanged($event)" [nzDropdownMatchSelectWidth]="false" nzDropdownClassName="dropdownSelect"
    [nzBorderless]="borderless" [nzDropdownRender]="null" [tabindex]="tabindex" class="width-100">
    <ng-template #displayTpl let-selected>
      {{ selected.nzLabel }}
    </ng-template>

    <!-- Custom Add New Button at top -->
    <ng-container *aclIf="'term.create'">
      <nz-option *ngIf="!searching && showAddNewButton && !this.NotShowInReport" [nzValue]="null" [nzLabel]="'__addnew__'" nzCustomContent>
        <div class="text-center">
          <button type="button" nz-button nzType="primary" class="add-new-button" (click)="$event.stopPropagation(); onAddNewClick($event)">
            <span nz-icon nzType="plus"></span>
            {{ storedInstantData ? ' Add New \''+ storedInstantData +'\'' : ' Add New' }}
          </button>
        </div>
      </nz-option>
    </ng-container>

    <ng-container *ngFor="let o of list">
      <nz-option *ngIf="!searching" [nzValue]="getValue(o)" [nzLabel]="o.code" nzCustomContent>
        <span>{{ o.code }}</span>
      </nz-option>
    </ng-container>
  </nz-select>

  <!-- Inline Add Panel -->
  <app-inline-add-panel #inlineAddPanel [config]="termConfig" [visible]="showInlineAddPanel"
    [initialData]="inlineDefaults" (itemCreated)="onTermCreated($event)" (cancelled)="onTermCancelled()"
    (visibleChange)="showInlineAddPanel = $event" (moreDetails)="onTermMoreDetails()"
    (fieldChange)="onFieldChange($event)">
  </app-inline-add-panel>
</div>